import * as React from "react";
import { XIcon } from "lucide-react";
import { Dialog, DialogClose, DialogContent } from "@sportscanner/ui";

function cn(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

const fullScreenOnMobile =
  // Position
  "max-md:!top-0 max-md:!left-0 max-md:!translate-x-0 max-md:!translate-y-0 " +
  // Size
  "max-md:!w-screen max-md:!max-w-none max-md:!h-svh max-md:!max-h-none " +
  // Chrome
  "max-md:!rounded-none max-md:!border-0 " +
  // Scroll + safe areas (top adds room so header/close clear the notch)
  "max-md:!overflow-y-auto " +
  "max-md:!pt-[max(env(safe-area-inset-top),1.5rem)] " +
  "max-md:!pb-[max(env(safe-area-inset-bottom),1.5rem)]";

function ResponsiveDialog(props: React.ComponentProps<typeof Dialog>) {
  return <Dialog {...props} />;
}

function ResponsiveDialogContent({
  className,
  children,
  ...props
}: Omit<React.ComponentProps<typeof DialogContent>, "showCloseButton">) {
  return (
    <DialogContent
      showCloseButton={false}
      className={cn(fullScreenOnMobile, className)}
      {...props}
    >
      <DialogClose className="ring-offset-background focus:ring-ring absolute right-4 top-4 max-md:top-[max(env(safe-area-inset-top),1rem)] rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none cursor-pointer">
        <XIcon className="size-4" />
        <span className="sr-only">Close</span>
      </DialogClose>
      {children}
    </DialogContent>
  );
}

export { ResponsiveDialog, ResponsiveDialogContent };
